import { stringHelper } from '@zg-rentals/rental-manager-env';

import { getSubPathList, LISTING_ALIAS_PATH_PREFIX_DELIMETERS, RMW_PATH, RMW_SUB_PATH } from './../pathsManifest';

/**
 * isPathADashboardIntention
 *
 * @param {string} path - The url path.
 * @returns {boolean} - Whether or not the intended path is one of the dashboard paths.
 */
const isPathADashboardIntention = ({ path = null }: { path: string | null }) => {
  const includesDashboardPath = path?.includes('dashboard');

  if (path === null || !includesDashboardPath) {
    return false;
  }

  const lastPart = stringHelper.getLastPieceFromPath(path);
  const validDashboardPathList = getSubPathList({ pathObj: RMW_PATH, subPathBase: RMW_SUB_PATH.DASHBOARD });
  let response = false;

  validDashboardPathList.every((validPath) => {
    if (`${RMW_SUB_PATH.DASHBOARD}/${lastPart}` === validPath) {
      response = true;
      return false;
    }

    return true;
  });

  return response;
};

const getDashboardOrSOHPath = ({
  canAccessDashboardRedesign,
  isMultifamily = false,
  listingAlias,
  propertiesPage,
}: {
  canAccessDashboardRedesign: boolean;
  isMultifamily?: boolean;
  listingAlias: string;
  propertiesPage: string;
}) => {
  const basePath = `${propertiesPage}/${listingAlias}/`;

  let subPath = null;

  if (isMultifamily === true) {
    subPath = 'listing';
  } else {
    subPath = canAccessDashboardRedesign ? `${RMW_SUB_PATH.DASHBOARD}/overview` : 'listing';
  }

  return `${basePath}${subPath}`;
};

const getListingAliasFromPath = (path = '') => {
  let listingAlias = '';
  LISTING_ALIAS_PATH_PREFIX_DELIMETERS.every((delimeter) => {
    const pathParts = path.split(delimeter);
    const pathParts2 = pathParts[1]?.split(/[/?]/) || [];
    if (pathParts2[0]?.length > 0) {
      // found the listingAlias, no need to continue
      listingAlias = pathParts2[0];
      return false;
    }
    return true;
  });
  return listingAlias;
};

export { getDashboardOrSOHPath, getListingAliasFromPath, isPathADashboardIntention };
